import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, GithubIcon, MailIcon } from 'lucide-react';
const Footer: React.FC = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-68">
      <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="md:flex md:justify-between md:space-x-10" data-id="element-70">
          <div className="mb-8 md:mb-0" data-id="element-71">
            <Link to="/" className="text-xl font-bold" data-id="element-72">
              Mohit Pole
            </Link>
            <p className="mt-2 text-gray-400 max-w-md text-sm" data-id="element-73">
              Senior Product Manager at Stealth Startup, specializing in
              AI-driven solutions that deliver exceptional user experiences and
              business outcomes.
            </p>
            <div className="mt-4 flex space-x-4" data-id="element-74">
              <a href="https://linkedin.com/in/mohitpole" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn Profile" data-id="element-75">
                <LinkedinIcon className="h-5 w-5" data-id="element-76" />
              </a>
              <a href="https://github.com/mohitpole" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="GitHub Profile" data-id="element-77">
                <GithubIcon className="h-5 w-5" data-id="element-78" />
              </a>
              <a href="mailto:mohitvoid@gmail.com" className="text-gray-400 hover:text-white transition-colors" aria-label="Email" data-id="element-79">
                <MailIcon className="h-5 w-5" data-id="element-80" />
              </a>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 md:grid-cols-2 md:gap-8" data-id="element-81">
            <div data-id="element-82">
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400" data-id="element-83">
                Navigation
              </h3>
              <div className="mt-4 space-y-2" data-id="element-84">
                <Link to="/" className="text-sm text-gray-400 hover:text-white block transition-colors" data-id="element-85">
                  Home
                </Link>
                <Link to="/about" className="text-sm text-gray-400 hover:text-white block transition-colors" data-id="element-86">
                  About
                </Link>
                <Link to="/#case-studies" className="text-sm text-gray-400 hover:text-white block transition-colors" data-id="element-87">
                  Case Studies
                </Link>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-white block transition-colors" data-id="element-88">
                  Contact
                </Link>
              </div>
            </div>
            <div data-id="element-89">
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400" data-id="element-90">
                Contact
              </h3>
              <div className="mt-4 space-y-2" data-id="element-91">
                <a href="mailto:mohitvoid@gmail.com" className="text-sm text-gray-400 hover:text-white block transition-colors" data-id="element-92">
                  mohitvoid@gmail.com
                </a>
                <a href="tel:+19374091223" className="text-sm text-gray-400 hover:text-white block transition-colors" data-id="element-93">
                  +1 (937) 409-1223
                </a>
                <p className="text-sm text-gray-500" data-id="element-94">Raleigh - Durham, NC</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-800 pt-6 md:flex md:items-center md:justify-between" data-id="element-95">
          <p className="text-sm text-gray-400" data-id="element-96">
            &copy; {new Date().getFullYear()} Mohit Pole. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;